import { IPojoDevice } from 'src/app/model/device/IPojoDevice';
import { IShaker } from 'src/app/model/device/IShaker';

export function isShaker(_: IPojoDevice): _ is IShaker {
  // TODO: This is a placeholder implementation. Replace with actual logic.
  return false;
}
